module.exports = __webpack_public_path__ + "img/calendarii.620d5e9f.svg";